import { render } from "./ParceiroTable.vue?vue&type=template&id=b1eeb31c"
import script from "./ParceiroTable.vue?vue&type=script&lang=js"
export * from "./ParceiroTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__